var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-snackbar',{attrs:{"right":"","top":"","value":_vm.updateExists,"timeout":50000,"color":"#2196f3"}},[_vm._v(" A newer version of this app is available "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.refreshApp}},[_vm._v(" Update ")])],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }